import { render, staticRenderFns } from "./TurnForm.vue?vue&type=template&id=7e4bc871&scoped=true&"
import script from "./TurnForm.vue?vue&type=script&lang=js&"
export * from "./TurnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4bc871",
  null
  
)

export default component.exports